import React from 'react';
import cn from 'classnames';
import {ComponentColor, StandardProps} from '..';

function getInputLabelColorClassName(color?: ComponentColor) {
  switch (color) {
    case 'inherit':
      return 'input-label__root--inherit';
    case 'primary':
      return 'input-label__root--primary';
    case 'secondary':
      return 'input-label__root--secondary';
    case 'tertiary':
      return 'input-label__root--tertiary';
    case 'error':
      return 'input-label__root--error';
    case 'info':
      return 'input-label__root--info';
    case 'success':
      return 'input-label__root--success';
    case 'warning':
      return 'input-label__root--warning';
    case 'gray':
      return 'input-label__root--gray';
    default:
      return '';
  }
}

export interface InputLabelProps extends StandardProps<React.LabelHTMLAttributes<HTMLLabelElement>> {
  color?: ComponentColor;
}

export const InputLabel = React.forwardRef<HTMLLabelElement, InputLabelProps>((props, ref) => {
  const {
    className,
    color,
    ...other
  } = props;

  return (
    <label
      className={cn(
        'input-label input-label__root',
        className,
        getInputLabelColorClassName(color),
      )}
      ref={ref}
      {...other}
    />
  );
});

export default InputLabel;
